import Slider from "../components/Slidbar/Slidbar";
import Table from "../components/SupportTickets/Table";

export const SupportTickets = () => {
  return (
    <>
      <Slider />
      <Table />
    </>
  );
};

export default SupportTickets;
